import { convertKeysToSnakeCase } from './convert-keys-to-snake-case'

export const EVENT_NAME_PREFIX = 'devexp_devdash'
export const EVENT_SPACE_KEY = 'SKEXJE'

export class TrackStrategy {
  /**
   * @param {object} tracker - The tracker object.
   * @param {(event: object) => void} tracker.recordClick - Method to record a click event.
   * @param {(event: object) => void} tracker.recordImpression - Method to record an impression event.
   */
  constructor(tracker) {
    this.tracker = tracker
  }

  /**
   * @param {object} event - The event object to track.
   * @throws {Error} Throws an error if not implemented by subclasses.
   */
  track() {
    throw new Error('This method should be implemented by subclasses')
  }
}

export class TrackClickStrategy extends TrackStrategy {
  /**
   * @type {EventNameBuilder}
   * @private
   */
  _eventNameBuilder

  /**
   * @param {object} tracker - The tracker object.
   * @param {EventNameBuilder} eventNameBuilder - The event name builder instance.
   */
  constructor(tracker, eventNameBuilder) {
    super(tracker)
    this._eventNameBuilder = eventNameBuilder
  }

  /**
   * @param {object} event - The event object to track.
   * @param {string} event.page - The page where the event occurred.
   * @param {string} event.component - The component where the event occurred.
   * @param {string} event.action - The action that triggered the event.
   * @returns {void}
   */
  track({ page, component, action, ...event }) {
    const eventName = this._eventNameBuilder
      .page(page)
      .component(component)
      .action(action)
      .build()
    const eventData = convertKeysToSnakeCase({
      ...event,
      eventName,
      spaceKey: EVENT_SPACE_KEY,
    })
    this.tracker.recordClick(eventData)
  }
}

export class TrackImpressionStrategy extends TrackStrategy {
  /**
   * @type {EventNameBuilder}
   * @private
   */
  _eventNameBuilder

  /**
   * @param {object} tracker - The tracker object.
   * @param {EventNameBuilder} eventNameBuilder - The event name builder instance.
   */
  constructor(tracker, eventNameBuilder) {
    super(tracker)
    this._eventNameBuilder = eventNameBuilder
  }

  /**
   * @param {object} event - The event object to track.
   * @param {string} event.page - The page where the event occurred.
   * @param {string} event.component - The component where the event occurred.
   * @param {string} event.action - The action that triggered the event.
   * @returns {void}
   */
  track({ page, component, action, ...event }) {
    const eventName = this._eventNameBuilder
      .page(page)
      .component(component)
      .action(action)
      .build()
    const eventData = convertKeysToSnakeCase({
      ...event,
      eventName,
      spaceKey: EVENT_SPACE_KEY,
    })
    this.tracker.recordImpression(eventData)
  }
}
